module.exports = __webpack_public_path__ + "img/abstract-shapes-14.71966b3a.svg";